import '../vendor/jquery.lazyload'

/**
*  Utility JavaScript functions
*/
var mobile_util = {};

/**
 * isIOS() returns a boolean indicating if the user is on a mobile iOS device
 */
mobile_util.isIOS = function () {
  return (/(iPad|iPhone|iPod)/i).test(navigator.userAgent);
};

/**
 * isIOSWebView() returns a boolean indicating if the user is viewing the page
 * via a UIWebView on iOS (i.e., within another app)
 */
mobile_util.isIOSWebView = function () {
  return this.isIOS() && !(/Safari/i).test(navigator.userAgent);
};

/**
* getIOSVersion() returns the top-level version of iOS as extracted from the
* UserAgent string (e.g., 10 for 10.0.1), or a falsey value if the UserAgent is
* not iOS
*/
mobile_util.getIOSVersion = function () {
  var regexp = new RegExp(/OS (\d+)/);
  var match = regexp.exec(navigator.userAgent);
  return this.isIOS() && match && match.length >= 2 && parseInt(match[1], 10);
};

/**
 * isSupportedIOS() returns a boolean indicating if the user is on an iOS8 or above device
 */
mobile_util.isSupportedIOS = function () {
  return this.getIOSVersion() >= 8;
};

/**
 * isMobile() returns a boolean indicating if the user is on a mobile device
 */

export let isMobile = function () {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent);
};

mobile_util.isMobile = isMobile;

/**
 * setCookie() sets the value of a cookie
 *
 * @param <String> name - name of the cookie who's value we're setting
 * @param <String> value - the value we are setting the cookie to
 * @param <Number> lifespan - number of days we want the cookie to persist for
 */
mobile_util.setCookie = function (name, value, lifespan) {
  value = value || 0;
  lifespan = lifespan || 7;

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + lifespan);

  document.cookie = name + "=" + value + "; expires=" + expirationDate +  "; path=/";
};

/**
 * getCookie() gets the value of a cookie
 *
 * @param <String> name - name of the cookie who's value we're getting
 */
mobile_util.getCookie = function (name) {
  var pattern = new RegExp(name + "=.[^;]*");
  var matched = document.cookie.match(pattern);

  if (matched) {
    return matched[0].split('=')[1];
  }

  return false;
};

export default mobile_util;
